import moment from 'moment';
import * as React from 'react';
import { isValidArray } from 'src/Library/Helper';

const SEFieldValue: React.FC<{
  value?: any;
  children?: any;
  displayNumber?: number;
  [key: string]: any;
}> = ({ value, children, displayNumber, ...props }) => {
  let label;

  /** for handling multiple values in case of select with multiple mode */
  if (isValidArray(value)) {
    label = value.join(', ');
  } else {
    /** label as single value in options or value itself */
    label = isValidArray(children)
      ? children.find((child) => child.key === value)?.props?.children
      : value;
  }

  return (
    <div style={{ color: '#111111', fontSize: '14px', fontWeight: 600 }}>
      {displayNumber && <span>{displayNumber}. </span>}
      {
        value instanceof moment
          ? (value as any).format('DD MMM YYYY | hh:mm A')
          : label || '-' /*JSON.stringify(value)*/
      }
    </div>
  );
};

export default SEFieldValue;
